const LINE_WIDTH = 92;
const LINES_PER_PAGE = 48;

const pdfEscape = (value) =>
  String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/\(/g, '\\(')
    .replace(/\)/g, '\\)');

const toPdfSafe = (value) =>
  Array.from(String(value || ''))
    .map((char) => {
      const code = char.charCodeAt(0);
      if (char === '\n' || char === '\r') return char;
      if (code < 32 || code > 126) return code === 9 ? '    ' : '?';
      return char;
    })
    .join('');

const wrapLines = (text) => {
  const lines = [];
  String(text || '').split(/\r?\n/).forEach((paragraph) => {
    if (!paragraph) {
      lines.push('');
      return;
    }
    let rest = paragraph;
    while (rest.length > LINE_WIDTH) {
      let breakAt = rest.lastIndexOf(' ', LINE_WIDTH);
      if (breakAt < 24) breakAt = LINE_WIDTH;
      lines.push(rest.slice(0, breakAt));
      rest = rest.slice(breakAt).trimStart();
    }
    lines.push(rest);
  });
  return lines.length ? lines : [''];
};

export const withFileExtension = (name, extension) => {
  const cleaned = String(name || '')
    .replace(/[\\/:*?"<>|]+/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 120);
  const fallback = stampFileName(extension).replace(/\.[^.]+$/, '');
  const base = cleaned || fallback;
  const ext = `.${extension}`;
  return base.toLowerCase().endsWith(ext) ? base : `${base}${ext}`;
};

export const stampFileName = (extension) => {
  const now = new Date();
  const stamp = [
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
    '-',
    String(now.getHours()).padStart(2, '0'),
    String(now.getMinutes()).padStart(2, '0'),
  ].join('');
  return `chat-text-${stamp}.${extension}`;
};

export const textToTxtFile = (text, fileName) => {
  const blob = new Blob([String(text || '')], { type: 'text/plain;charset=utf-8' });
  return new File([blob], withFileExtension(fileName, 'txt'), { type: 'text/plain' });
};

export const textToPdfFile = (text, fileName) => {
  const lines = wrapLines(toPdfSafe(text));
  const pages = [];
  for (let i = 0; i < lines.length; i += LINES_PER_PAGE) {
    pages.push(lines.slice(i, i + LINES_PER_PAGE));
  }

  const objects = [];
  const addObject = (body) => {
    objects.push(body);
    return objects.length;
  };

  const catalogId = addObject('<< /Type /Catalog /Pages 2 0 R >>');
  const pagesId = addObject('');
  const fontId = addObject('<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica >>');
  const pageIds = [];
  const contentIds = [];

  pages.forEach((pageLines) => {
    const stream = [
      'BT',
      '/F1 11 Tf',
      '14 TL',
      '50 742 Td',
      pageLines.map((line, lineIndex) => (
        lineIndex === 0 ? `(${pdfEscape(line)}) Tj` : `(${pdfEscape(line)}) '`
      )).join('\n'),
      'ET',
    ].join('\n');
    const pageId = addObject('');
    const contentId = addObject(`<< /Length ${stream.length} >>\nstream\n${stream}\nendstream`);
    pageIds.push(pageId);
    contentIds.push(contentId);
    objects[pageId - 1] = `<< /Type /Page /Parent ${pagesId} 0 R /MediaBox [0 0 612 792] /Contents ${contentId} 0 R /Resources << /Font << /F1 ${fontId} 0 R >> >> >>`;
  });

  objects[pagesId - 1] = `<< /Type /Pages /Count ${pageIds.length} /Kids [${pageIds.map((id) => `${id} 0 R`).join(' ')}] >>`;
  void catalogId;

  let pdf = '%PDF-1.4\n';
  const offsets = [0];
  objects.forEach((body, index) => {
    offsets[index + 1] = pdf.length;
    pdf += `${index + 1} 0 obj\n${body}\nendobj\n`;
  });
  const xrefStart = pdf.length;
  pdf += `xref\n0 ${objects.length + 1}\n0000000000 65535 f \n`;
  for (let i = 1; i <= objects.length; i += 1) {
    pdf += `${String(offsets[i]).padStart(10, '0')} 00000 n \n`;
  }
  pdf += `trailer\n<< /Size ${objects.length + 1} /Root 1 0 R >>\nstartxref\n${xrefStart}\n%%EOF\n`;
  const blob = new Blob([pdf], { type: 'application/pdf' });
  return new File([blob], withFileExtension(fileName, 'pdf'), { type: 'application/pdf' });
};
